// Version of the running application (lot 29, V2). The bundle carries the version it was built with (REACT_APP_*, injected by the
// frontend Dockerfile); `GET /api/version` says what the server runs now. A tab left open on old code sees the two differ.

// A release is a published number `X.Y.Z` (lot S2; the major never has 4 digits) or, until the emitters moved, a calendar one `AAAA.MM.N`.
const RELEASE = /^(\d{4}\.\d{2}\.\d+|\d{1,3}\.\d+\.\d+)$/;

export function bundleInfo(env = process.env) {
  return {
    version: env.REACT_APP_VERSION || "dev",
    gitSha: env.REACT_APP_GIT_SHA || "unknown",
    buildDate: env.REACT_APP_BUILD_DATE || "unknown",
  };
}

export const isReleaseVersion = (version) => RELEASE.test(version || "");

// A new version is only announced when BOTH sides are real releases: a local build (« dev ») or an unreadable answer never
// raises the banner.
export function isNewerVersionAvailable(bundleVersion, serverVersion) {
  return isReleaseVersion(bundleVersion) && isReleaseVersion(serverVersion) && bundleVersion !== serverVersion;
}

export const versionLabel = (version) => (isReleaseVersion(version) ? version : version || "dev");

export function versionTitle({ version, gitSha, buildDate }) {
  const parts = [`Version ${versionLabel(version)}`];
  if (gitSha && gitSha !== "unknown") parts.push(`commit ${gitSha}`);
  if (buildDate && buildDate !== "unknown") {
    const date = new Date(buildDate);
    if (!Number.isNaN(date.getTime())) parts.push(`construite le ${date.toLocaleDateString("fr-FR")}`);
  }
  return parts.join(" · ");
}

// What the server answered, kept only when it has the expected shape.
export function readServerVersion(body) {
  return body && typeof body.version === "string" && body.version ? body.version : null;
}
